import IconDown from "./icon-down";

export default IconDown;
